/**
 * Async-clipboard GIF support is narrow (Chromium 121+ via
 * `ClipboardItem.supports`), so we feature-detect and hide the action
 * entirely where it can't work rather than failing at click time.
 */
export function canCopyGif(): boolean {
  if (typeof window === 'undefined') return false;
  if (!('clipboard' in navigator) || typeof navigator.clipboard.write !== 'function') return false;
  if (typeof ClipboardItem === 'undefined') return false;
  const supports = (
    ClipboardItem as typeof ClipboardItem & { supports?: (type: string) => boolean }
  ).supports;
  return typeof supports === 'function' ? supports('image/gif') : false;
}

export async function copyGifToClipboard(blob: Blob): Promise<void> {
  const item = new ClipboardItem({ 'image/gif': blob });
  await navigator.clipboard.write([item]);
}
